
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_204_38)"}},[_c('path',{attrs:{"d":"M15.679.346h2.038v2.727c3.647.02 7.29-.038 10.934.02.776-.078 1.386.525 1.315 1.302.058 6.714-.014 13.431.034 20.145-.034.689.068 1.452-.33 2.062-.498.355-1.143.31-1.722.337-3.412-.016-6.82-.01-10.231-.01v2.727h-2.13C10.4 28.71 5.199 27.84.002 26.93c-.004-7.951 0-15.903 0-23.85C5.226 2.166 10.454 1.277 15.679.346z","fill":"#2A5699"}}),_c('path',{attrs:{"d":"M17.717 4.095h11.247v21.812H17.717v-2.726h8.86v-1.364h-8.86v-1.704h8.86V18.75h-8.86v-1.704h8.86v-1.363h-8.86v-1.704h8.86v-1.363h-8.86V10.91h8.86V9.548h-8.86V7.844h8.86V6.481h-8.86V4.095zM7.043 10.117c.647-.037 1.295-.064 1.942-.099.453 2.301.917 4.598 1.408 6.888.385-2.365.811-4.723 1.223-7.085a80.29 80.29 0 002.042-.102c-.77 3.302-1.445 6.632-2.287 9.914-.57.296-1.422-.014-2.097.034-.453-2.256-.981-4.499-1.387-6.765-.398 2.201-.916 4.383-1.373 6.57-.654-.033-1.312-.074-1.97-.119-.566-2.999-1.23-5.977-1.759-8.983.583-.028 1.17-.052 1.752-.072.351 2.17.75 4.332 1.057 6.506.481-2.229.971-4.458 1.449-6.687z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_204_38"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    